import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";

import Loader from "../Loader";

import { useUserStore } from "../../store/userStore";
import { requestNotificationPermission } from "../../firebase";
import { isMobile } from "../../utils/helpers";
import { useIsPWAInstalled } from "../../hooks/useIsPWAInstalled";

import "./style.scss";

const NotificationPopup = () => {
  const { t } = useTranslation();
  const isPWA = useIsPWAInstalled();
  const { user } = useUserStore();
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
  const dontRequestAgain = JSON.parse(localStorage.getItem("dontRequestAgain"));
  const decodedToken = ps10005000 ? jwtDecode(ps10005000) : null;

  useEffect(() => {
    const readAndSetPopup = () => {
      const storedValue = localStorage.getItem(
        `requestNotificationPermission${user?.type}`,
      );
      const showPopup = storedValue ? JSON.parse(storedValue) : false;

      if (!isMobile) return;

      if (isPWA && "Notification" in window) {
        const permission = Notification?.permission;
        setShowPopup(showPopup && permission === "default");
      } else if (showPopup && !dontRequestAgain) {
        localStorage.removeItem("ps10003000");
        window.dispatchEvent(new Event("localStorageChangedPwa"));
      }
    };

    // Run on mount
    readAndSetPopup();

    // Listen for custom event
    window.addEventListener(
      "localStorageChangedNotifications",
      readAndSetPopup,
    );
    return () => {
      window.removeEventListener(
        "localStorageChangedNotifications",
        readAndSetPopup,
      );
    };
  }, [user]);

  const handleReject = () => {
    localStorage.removeItem(`requestNotificationPermission${user?.type}`);
    setShowPopup(false);
  };

  const handleAllow = async () => {
    setLoading(true);
    try {
      await requestNotificationPermission(ps10005000, decodedToken.buid);
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    } finally {
      setShowPopup(false);
      setLoading(false);
      localStorage.removeItem(`requestNotificationPermission${user?.type}`);
    }
  };

  if (!showPopup || dontRequestAgain) return null;

  return (
    <div className="overlay">
      {loading && <Loader />}
      <div className="popup">
        <h2 className="popup-title">{t("notifications_permission_title")}</h2>
        <p className="popup-message">{t("notifications_permission_text")}</p>
        <p className="popup-message">{t("notifications_permission_subtext")}</p>
        <div className="dont-ask-again">
          <input
            type="checkbox"
            id="ask"
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem("dontRequestAgain", true);
              } else {
                localStorage.removeItem("dontRequestAgain");
              }
            }}
          />
          <label htmlFor="ask">{t("dont_ask_again")}</label>
        </div>
        <div className="permission_buttons-container">
          <button className="reject" onClick={handleReject}>
            {t("deny")}
          </button>
          <button className="allow" onClick={handleAllow}>
            {t("allow")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
